import * as types from 'legacy/src/constants/types';

const questionBySharedStimulus = (state = {}, action) => {
  switch (action.type) {
    case types.SET_QUESTION_BY_STIMULUS:
      return {
        ...state,
        [action.stimulus]: action.payload,
      };
    default:
      return state;
  }
};

export default questionBySharedStimulus;
